import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export default function clientRequestsSummaryReducer(state = initialState.clientRequestsSummary, action) {
	switch (action.type) {
		case types.GET_CLIENT_REQUESTS_SUMMARY: {
			return action?.response;
		}

		default:
			return state;
	}
}
